import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_GROUPITEMTEMPLATE_LOAD,
    ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID,

    ACTION_GROUPITEMTEMPLATE_SAVE,

    ACTION_GROUPITEMTEMPLATE_CREATE,

    ACTION_GROUPITEMTEMPLATE_VALIDATE,

    IGroupItemTemplateLoadAction,
    IGroupItemTemplateLoadByIdAction,
    IGroupItemTemplateLoadFailureAction,
    IGroupItemTemplateLoadSuccessAction,

    IGroupItemTemplateSaveAction,
    IGroupItemTemplateSaveSuccessAction,
    IGroupItemTemplateSaveFailureAction,

    IGroupItemTemplateCreateAction,
    IGroupItemTemplateCreateSuccessAction,
    IGroupItemTemplateCreateFailureAction,

    IGroupItemTemplateValidateAction,
    IGroupItemTemplateValidateSuccessAction,
    IGroupItemTemplateValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/groupItemTemplate";
import { groupItemTemplatesApi } from "../services/groupItemTemplates";


export const
    getGroupItemTemplatesEpic = (action$): Observable<IGroupItemTemplateLoadSuccessAction | IGroupItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATE_LOAD)
            .mergeMap((action: IGroupItemTemplateLoadAction) => {
                return groupItemTemplatesApi
                    .getGroupItemTemplates(action.groupId)
                    .map(response =>
                        LoadSuccess(response.groupItemTemplates, response.groupItemsByCategory, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getGroupItemTemplatesByIdEpic = (action$): Observable<IGroupItemTemplateLoadSuccessAction | IGroupItemTemplateLoadFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATE_LOAD_BY_ID)
            .mergeMap((action: IGroupItemTemplateLoadByIdAction) => {
                return groupItemTemplatesApi
                    .getGroupItemTemplateById(action.id)
                    .map(response =>
                        LoadSuccess(response.groupItemTemplate, undefined, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setGroupItemTemplateEpic = (action$): Observable<IGroupItemTemplateSaveSuccessAction | IGroupItemTemplateSaveFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATE_SAVE)
            .mergeMap((action: IGroupItemTemplateSaveAction) => {
                return groupItemTemplatesApi
                    .setGroupItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.groupItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createGroupItemTemplateEpic = (action$): Observable<IGroupItemTemplateCreateSuccessAction | IGroupItemTemplateCreateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATE_CREATE)
            .mergeMap((action: IGroupItemTemplateCreateAction) => {
                return groupItemTemplatesApi
                    .createGroupItemTemplate(action.groupId)
                    .map(response =>
                        CreateSuccess(response.groupItemTemplate, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateGroupItemTemplateEpic = (action$): Observable<IGroupItemTemplateValidateSuccessAction | IGroupItemTemplateValidateFailureAction> => {
        return action$
            .ofType(ACTION_GROUPITEMTEMPLATE_VALIDATE)
            .mergeMap((action: IGroupItemTemplateValidateAction) => {
                return groupItemTemplatesApi
                    .validateGroupItemTemplate(action.formData, action.collectionFormData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.groupItemTemplate, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }


